import React from 'react';
import LegalPageLayout, { LegalSection } from '../components/legal/LegalPageLayout';
import styles from './LegalPages.module.css';

const NAV_ITEMS = [
  { id: 'privacy-collect', label: 'Information we collect' },
  { id: 'privacy-use', label: 'How we use data' },
  { id: 'privacy-share', label: 'Data sharing' },
  { id: 'privacy-security', label: 'Data security' },
  { id: 'privacy-cookies', label: 'Cookies & analytics' },
  { id: 'privacy-retention', label: 'Data retention' },
  { id: 'privacy-rights', label: 'Your rights' },
  { id: 'privacy-contact', label: 'Contact' },
];

const PrivacyPolicy = () => (
  <LegalPageLayout
    badge="Legal information"
    title="Privacy"
    highlight="Policy"
    subtitle="Greeneri Paper Tradelinks values your privacy. This policy explains what information we collect, how we use it, and the choices you have when using our website and enquiry forms."
    navItems={NAV_ITEMS}
  >
    <LegalSection id="privacy-collect" number={1} title="Information We Collect">
      <p className={styles.text}>
        We may collect your name, business email, phone number, company name, country, and requirement
        details when you submit enquiry or quote forms. We also collect basic technical information such
        as browser type, device type, and website usage behavior for analytics and performance
        improvements.
      </p>
    </LegalSection>

    <LegalSection id="privacy-use" number={2} title="How We Use Your Information">
      <ul className={styles.list}>
        <li>To respond to product enquiries, quote requests, and support messages.</li>
        <li>To share product details, technical data, and order-related communication.</li>
        <li>To improve our website, user experience, and service quality.</li>
        <li>To comply with legal and regulatory obligations where applicable.</li>
      </ul>
    </LegalSection>

    <LegalSection id="privacy-share" number={3} title="Data Sharing and Disclosure">
      <p className={styles.text}>
        We do not sell or rent your personal information. Your data may be shared only with trusted
        service providers (such as hosting, email, or CRM tools) who assist in business operations under
        confidentiality obligations, or when required by law.
      </p>
    </LegalSection>

    <LegalSection id="privacy-security" number={4} title="Data Security">
      <p className={styles.text}>
        We use reasonable technical and organizational safeguards to protect your information from
        unauthorized access, misuse, or disclosure. However, no internet transmission or storage method
        is fully risk-free.
      </p>
    </LegalSection>

    <LegalSection id="privacy-cookies" number={5} title="Cookies and Analytics">
      <p className={styles.text}>
        Our website may use cookies or similar technologies to analyze traffic, remember preferences,
        and improve content relevance. You can manage cookie settings through your browser preferences.
      </p>
    </LegalSection>

    <LegalSection id="privacy-retention" number={6} title="Data Retention">
      <p className={styles.text}>
        We retain enquiry and business communication data only as long as needed for customer support,
        order discussion, business record keeping, and compliance needs.
      </p>
    </LegalSection>

    <LegalSection id="privacy-rights" number={7} title="Your Rights">
      <p className={styles.text}>
        You may request access, correction, or deletion of personal data that you have shared with us,
        subject to legal and operational limitations.
      </p>
    </LegalSection>

    <LegalSection id="privacy-contact" number={8} title="Contact for Privacy Queries">
      <p className={styles.text}>
        For privacy-related requests, contact us at <strong>info@greeneripapers.com</strong> or call{' '}
        <strong>+91 9557005492</strong>.
      </p>
    </LegalSection>
  </LegalPageLayout>
);

export default PrivacyPolicy;
